// extracted by mini-css-extract-plugin
module.exports = {"item":"footer_item-module--item--3sWIR"};